<span class="summary" (click)="toggleChooser()" evt.target.checked>{{summary}}</span>
<div class="item-list" [hidden]="!showItems" (mouseleave)="hideChooser()">
	<label for="">All</label>
		<input type="checkbox" (change)="allChanged($event)" [disabled]="isDisabled">
	<div class="item" *ngFor="let item of items">
		<label for="">{{item.name}}</label>
		<input type="checkbox" [(ngModel)]="item.selected" [disabled]="isDisabled" >
	</div>
</div>